if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
  const clickedMediaId = this.openedBy.getAttribute('data-media-id');
  const clickedMedia = this.querySelector(`[data-media-id="${clickedMediaId}"]`);
  const activeMediaTemplate = clickedMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

  // Hide all media elements except the clicked one
  this.querySelectorAll('[data-media-id]').forEach((element) => {
    if (element !== clickedMedia) {
      element.style.display = 'none';
    }
  });

  // Display the clicked media element
  clickedMedia.style.display = 'block';
  clickedMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (clickedMedia.width - container.clientWidth) / 2;

  if (
    clickedMedia.nodeName == 'DEFERRED-MEDIA' &&
    activeMediaContent &&
    activeMediaContent.querySelector('.js-youtube')
  ) {
    clickedMedia.loadContent();
  }
}


    }
  );
}
